import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { retourenRoutes } from '@softapps/mde/retouren';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { gutscheinkartenRoutes } from '@softapps/handel/gutscheinkarten';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { checklisteRoutes } from '@softapps/allgemein/checkliste';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  //Wws
  ...gesamtabfrageRoutes,
  // ...stempelerfassungRoutes

  // MDE
  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...lagerInventurRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...artikelvorratRoutes,

  ...artikelInfoRoutes,

  ...gutscheinkartenRoutes,
  ...checklisteRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      //Wws
      ...gesamtabfrageRoutes,
      // ...stempelerfassungRoutes

      // MDE
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...artikelvorratRoutes,

      ...artikelInfoRoutes,

      ...gutscheinkartenRoutes,
      ...checklisteRoutes,
      ...deliveryNoteProcessingRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
];
*/
